import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import toast, { Toaster } from 'react-hot-toast';
import { validateAdminPassword, decrementStockById, incrementStockById } from '../utils/adminUtils';
import { getFigurineImageSrc } from '../utils/figurineMedia';

export default function AdminPage() {
  const { id } = useParams();
  const [password, setPassword] = useState('');
  const [isAdmin, setIsAdmin] = useState(sessionStorage.getItem('isAdmin') === 'true');
  const [figure, setFigure] = useState(null);

  const handleLogin = (password) => {
    if (validateAdminPassword(password)) {
      setIsAdmin(true);
      sessionStorage.setItem('isAdmin', 'true');
      fetchFigure();
    } else {
      toast.error("Incorrect password");
    }
  };

  const fetchFigure = async () => {
    if (!id) return;
    const { data, error } = await supabase.from('figurines').select('*').eq('id', id).single();
    if (error) {
      console.error(error);
      toast.error("Failed to load figure");
    } else {
      setFigure(data);
    }
  };

  const handleDecrement = async () => {
    const success = await decrementStockById(id);
    if (success) fetchFigure();
  };

  const handleIncrement = async () => {
    const success = await incrementStockById(id);
    if (success) fetchFigure();
  };

  useEffect(() => {
    if (isAdmin && id) fetchFigure();
  }, [id, isAdmin]);

  if (!isAdmin) {
    return (
      <div className="nfig-page flex flex-col items-center justify-center">
        <Toaster position="top-center" />
        <h2 className="relative z-10 mb-4 text-2xl font-black uppercase">Admin Login</h2>
        <input
          type="password"
          placeholder="Enter admin password"
          className="nfig-input relative z-10 mb-4 max-w-xs"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') handleLogin(password); }}
        />
        <button
          onClick={() => handleLogin(password)}
          className="nfig-button-primary relative z-10 w-full max-w-xs"
        >
          Login
        </button>
      </div>
    );
  }

  if (!figure) {
    return (
      <div className="nfig-page flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="nfig-page flex flex-col items-center">
      <Toaster position="top-center" />
      <h2 className="nfig-page-title relative z-10 mb-8 text-center">Manage Stock</h2>

      <div className="nfig-panel relative z-10 w-full max-w-md rounded-2xl p-6 text-center">
        <img
          src={getFigurineImageSrc(figure)}
          alt={figure.name}
          className="w-full h-48 object-contain mb-4"
        />
        <h2 className="text-2xl font-semibold">{figure.name}</h2>
        <p className="text-blue-300">{figure.series}</p>
        <p className="mt-2 text-xl font-bold text-white">₪{figure.value}</p>

        <div className="flex gap-4 justify-center mt-4">
          <button
            onClick={handleDecrement}
            className="rounded-lg border border-red-400/30 bg-red-500/10 px-5 py-2 text-lg text-red-200 hover:bg-red-500/20"
          >
            ➖
          </button>
          <button
            onClick={handleIncrement}
            className="rounded-lg border border-emerald-400/30 bg-emerald-500/10 px-5 py-2 text-lg text-emerald-200 hover:bg-emerald-500/20"
          >
            ➕
          </button>
        </div>

        <p className="mt-4 text-lg font-bold text-blue-300">
          Stock: {figure.stock}
        </p>
      </div>
    </div>
  );
}
